export default {
    getError404(state) {
        return state.error404;
    },
};
